import UserApi from "@/api/user/UserApi";

const defaultAllowState = () => ({
  vod: 0,
  aes: 0,
  hls: 0,
  webrtc: 0,
  ai_transcript: null,
  social_integration: null,
  social_publish: null,
  social_live: null,
});

const state = {
  selectedItem: null,
  drawer: true,
  mini: false,
  showTestComponent: false,
  items: [],
  allowList: defaultAllowState(),
  allowInitialized: false,
};

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
  updateItems(state, items) {
    state.items = items;
  },
  SET_ALLOW(state, allowList){
    state.allowList = {
      ...defaultAllowState(),
      ...(allowList || {})
    };
    state.allowInitialized = true;
  }
};

const actions = {
  async list({ commit }) {
    try {
      const response = await UserApi.menuListApi();
      if (Array.isArray(response.menuTree)) {
        commit('SET_ITEMS', response.menuTree);
        commit('SET_ALLOW', response.allow);
      } else {
        console.error('error', response);
      }
    } catch (error) {
      console.error('error', error);
    }
  }
};

const truthyStrings = new Set(['1', 'true', 'y', 'yes', 'on', 'enable', 'enabled']);
const falsyStrings = new Set(['0', 'false', 'n', 'no', 'off', 'disable', 'disabled']);

const toBool = (value) => {
  if (value === null || value === undefined || value === '') {
    return undefined;
  }

  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'number') {
    return value !== 0;
  }

  const normalized = String(value).trim().toLowerCase();

  if (!normalized.length) {
    return undefined;
  }

  if (truthyStrings.has(normalized)) {
    return true;
  }

  if (falsyStrings.has(normalized)) {
    return false;
  }

  const numeric = Number(normalized);
  if (!Number.isNaN(numeric)) {
    return Boolean(numeric);
  }

  return undefined;
};

const getters = {
  allowList: state => state.allowList,
  allowInitialized: state => state.allowInitialized,
  permissionMap: (state) => {
    const list = state.allowList || defaultAllowState();
    const resolve = (key) => {
      if (!Object.prototype.hasOwnProperty.call(list, key)) {
        return undefined;
      }
      return toBool(list[key]);
    };
    return {
      vod: resolve('vod'),
      aes: resolve('aes'),
      hls: resolve('hls'),
      webrtc: resolve('webrtc'),
      aiTranscript: resolve('ai_transcript'),
      socialIntegration: resolve('social_integration'),
      socialPublish: resolve('social_publish'),
      socialLive: resolve('social_live') ?? resolve('33'),
    };
  },
  hasAiTranscript: (state, getters) => {
    const val = getters.permissionMap.aiTranscript;
    return val === undefined ? true : val;
  },
  hasSocialIntegration: (state, getters) => {
    const val = getters.permissionMap.socialIntegration;
    return val === undefined ? true : val;
  },
  hasSocialPublish: (state, getters) => {
    const val = getters.permissionMap.socialPublish;
    return val === undefined ? true : val;
  },
  hasSocialLive: (state, getters) => {
    const val = getters.permissionMap.socialLive;
    return val === undefined ? true : val;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
